var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"prompt-cell",attrs:{"title":_vm.title},on:{"ok":_vm.ok,"cancel":_vm.cancel},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',[_c('a-input',{attrs:{"placeholder":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }